<div class="card border-0 shadow-sm">
	<div class="card-header bg-accent text-white d-flex justify-content-between align-items-center">
		<strong>المسح عبر الكاميرا (مجاني)</strong>
		<button class="btn btn-sm btn-outline-light" (click)="close()"><i class="bi bi-x-lg"></i></button>
	</div>
	<div class="card-body">
		<div *ngIf="error" class="alert alert-danger">{{error}}</div>
		<div class="ratio ratio-16x9 mb-3" style="background:#000;border-radius:.5rem;overflow:hidden;">
			<video id="scanVideo" playsinline muted></video>
		</div>
		<div class="row g-2 mb-3">
			<div class="col-md-3 d-flex align-items-center">
				<div class="form-check">
					<input class="form-check-input" type="checkbox" id="autoEnhance" [(ngModel)]="autoEnhance">
					<label class="form-check-label" for="autoEnhance">تحسين تلقائي</label>
				</div>
			</div>
			<div class="col-md-3 d-flex align-items-center">
				<div class="form-check">
					<input class="form-check-input" type="checkbox" id="enforceA4" [(ngModel)]="enforcingA4">
					<label class="form-check-label" for="enforceA4">تناسق A4</label>
				</div>
			</div>
			<div class="col-md-3">
				<label class="form-label">سطوع {{brightness}}</label>
				<input type="range" class="form-range" min="-100" max="100" [(ngModel)]="brightness">
			</div>
			<div class="col-md-3">
				<label class="form-label">تباين {{contrast}}</label>
				<input type="range" class="form-range" min="-100" max="100" [(ngModel)]="contrast">
			</div>
		</div>
		<div class="d-flex gap-2">
			<button class="btn btn-primary" (click)="capture()" [disabled]="!!error || isStarting">
				<i class="bi bi-camera"></i> التقاط
			</button>
			<button class="btn btn-outline-secondary" (click)="start()" [disabled]="isStarting">
				<i class="bi bi-arrow-clockwise"></i> إعادة التشغيل
			</button>
			<button class="btn btn-outline-danger ms-auto" (click)="close()">
				<i class="bi bi-x-circle"></i> إغلاق
			</button>
		</div>
	</div>
</div>


